<template>
  <!-- <div class="add-address" v-if="isShow"> -->
  <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="isShow" @closed="hide" width="713px">
    <!-- <div class="address-cn"> -->
    <el-form :model="ruleForm" :rules="rules" hide-required-asterisk label-position="top" style="padding:0 10px;" ref="ruleForm">
      <el-form-item label="智能识别" prop="allMessage" placeholder="粘贴或输入内容，自动识别姓名、电话和地址">
        <div class="textarea-box">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" v-model="allMessage"></el-input>
          <div class="recognize" @click="parseAddress">智能识别</div>
        </div>
      </el-form-item>
      <div class="address-top">
        <el-form-item label="收货人" class="form-username fn-left" prop="person">
          <el-input type="text" v-model.trim="ruleForm.person" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" class="form-phone fn-right" prop="phone">
          <el-input type="number" v-model.number="ruleForm.phone" autocomplete="off"></el-input>
          <!-- <input type="number" v-model="ruleForm.phone" /> -->
        </el-form-item>
      </div>
      <!-- <div class="address-list"> -->
      <el-form-item label="地址信息" prop="address">
        <el-select v-model="address.province" value-key='code' @change="getCityList" style="width:214px" placeholder="请选择">
          <el-option v-for="item in proList" :key="item.code" :label="item.name" :value="item"></el-option>
        </el-select>
        <el-select v-model="address.city" @change="getCountyList" value-key='id' style="width:214px;margin:0 5px" placeholder="请选择">
          <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item"></el-option>
        </el-select>
        <el-select v-model="address.county" value-key='id' style="width:214px" @change="$refs.ruleForm.validateField('address')" placeholder="请选择">
          <el-option v-for="item in CountyList" :key="item.id" :label="item.name" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <!-- </div> -->
      <el-form-item label="详细地址" prop="fullAddress">
        <el-input v-model.trim="ruleForm.fullAddress" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"></el-input>
      </el-form-item>
    </el-form>
    <div class="btn_box">
      <el-button @click="submit" type="primary" round>确定</el-button>
      <el-button @click="hide" round type="primary" style="background: #aaa !important;">取消</el-button>
    </div>
    <!-- <button @click="submit">确定</button> -->
    <!-- <button @click="hide" class="cancel">取消</button> -->
    <!-- </div> -->
  </el-dialog>
  <!-- </div> -->
</template>
<script>
import AddressParse from 'address-parse'
import { addressGetAllProvince, addressGetCityByProvinceCode, addressGetCountyByCityId } from '@/api/addr'
import { addressUpdate, saveUserAddress, addressGetAddressById } from '@/api/crm'
export default {
  name: 'add-address',
  props: ['value'],
  data () {
    // 校验手机号
    var checkPhone = (rule, value, callback) => {
      const regPhone = /^1[0-9]\d{9}$/
      if (regPhone.test(value)) {
        return callback()
      } else {
        callback(new Error('请输入合法的手机号'))
      }
    }
    var checkAddress = (rule, value, callback) => {
      if (!!this.address.province.code && !!this.address.city.id && !!this.address.county.id) {
        callback()
      } else {
        callback(new Error('请选择完整的地址'))
      }
    }
    return {
      allMessage: '',
      title: '添加地址',
      rules: {
        person: [
          { required: true, message: '请输入收货人名称', trigger: 'blur' },
          { max: 10, message: '长度不能超过10', trigger: 'blur' }
        ],
        // { validator: checkPhone, trigger: 'blur' },
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        address: [
          { validator: checkAddress, trigger: 'blur' }
        ],
        fullAddress: [
          { required: true, message: '请输入详细信息', trigger: 'blur' },
          { max: 45, message: '长度不能超过45', trigger: 'blur' }
        ]
      },
      address: {
        province: {},
        city: {},
        county: {}
      },
      isShow: false,
      ruleForm: {
        city: '',
        cityId: null,
        county: '',
        countyId: null,
        fullAddress: '',
        person: '',
        phone: '',
        province: '',
        provinceCode: '',
        userId: this.$store.state.user.userId
      },
      proList: [],
      cityList: [],
      CountyList: [],
      showType: '',
      addressIndex: '',
      lock: false,
      index: null
    }
  },
  methods: {
    // 粘贴信息，自动拆分姓名、电话和地址
    async parseAddress () {
      if (this.allMessage != '') {
        const result = AddressParse.parse(this.allMessage)
        console.log('result++', result)
        this.ruleForm.person = result[0].name
        this.ruleForm.phone = result[0].mobile || result[0].phone
        this.ruleForm.fullAddress = result[0].details
        this.address.province = this.proList.find(a => a.name.includes(result[0].province))
        if (!this.address.province) {
          return
        }
        await this.getCityList()
        this.address.city = this.cityList.find(a => a.name == result[0].city)
        if (!this.address.city) {
          return
        }
        await this.getCountyList()
        this.address.county = this.CountyList.find(a => a.name == result[0].area)
      } else {
        this.$toast('请输入您要识别的地址')
      }
    },
    show (type, item, index) {
      console.log('展示不对三点')
      this.isShow = true
      this.showType = type
      this.addressIndex = ''
      this.getAllPro()
      if (type === 'add') {
        this.title = '添加地址'
        // this.ruleForm.username = ''
        this.index = index
        this.ruleForm.phone = ''
      }
      if (type === 'edit') {
        this.title = '编辑地址'
        this.addressIndex = index
        this.ruleForm.id = item.id
        this.ruleForm.person = item.person
        this.ruleForm.fullAddress = item.fullAddress
        this.address.province = { code: item.provinceCode, name: item.province }
        this.address.city = { id: item.cityId, name: item.city }
        this.address.county = { id: item.countyId, name: item.county }
        // this.ruleForm.username = item.username
        this.ruleForm.phone = item.phone
        this.getCityList()
        this.getCountyList()
      }
    },
    async getAddressById (id) {
      await addressGetAddressById(id).then(res => {
        if (res.data.success) {
          this.$emit('changeAddress', this.addressIndex, res.data.data)
        }
      })
    },
    hide () {
      this.allMessage = ''
      this.ruleForm = {
        city: '',
        cityId: null,
        county: '',
        countyId: null,
        fullAddress: '',
        person: '',
        phone: '',
        province: '',
        provinceCode: '',
        userId: this.$store.state.user.userId
      }
      this.address = {
        province: {},
        city: {},
        county: {}
      }
      this.cityList = []
      this.CountyList = []
      this.$refs.ruleForm.resetFields()
      this.isShow = false
    },
    submit () {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          return
        }
        if (this.lock) {
          return
        }
        this.lock = true
        this.ruleForm.province = this.address.province.name
        this.ruleForm.provinceCode = this.address.province.code
        this.ruleForm.city = this.address.city.name
        this.ruleForm.cityId = this.address.city.id
        this.ruleForm.county = this.address.county.name
        this.ruleForm.countyId = this.address.county.id

        if (this.showType === 'add') {
          saveUserAddress(this.ruleForm).then(res => {
            if (res.data.success) {
              this.$notify({
                title: '成功',
                message: '添加成功',
                type: 'success'
              })
              console.log('添加成功')
              this.$emit('getList')
              this.$emit('changeAddress', this.index, res.data.data)
              this.hide()
            }
            this.lock = false
          })
        } else if (this.showType === 'edit') {
          addressUpdate(this.ruleForm).then(res => {
            if (res.data.success) {
              // this.$notify({
              //   title: '成功',
              //   message: '修改成功',
              //   type: 'success'
              // })
              this.getAddressById(this.ruleForm.id)
              this.hide()
            }
            this.lock = false
          })
        }
      })
    },
    getAllPro () {
      addressGetAllProvince().then(res => {
        if (res.data.success) {
          this.proList = res.data.data
        }
      })
    },
    async getCityList (val) {
      await addressGetCityByProvinceCode(this.address.province.code).then(res => {
        this.cityList = res.data.data
        if (
          !this.cityList.some(item => {
            return item.id === this.address.city.id
          })
        ) {
          this.address.city = {}
          this.address.county = {}
        }
      })
    },
    async getCountyList (val) {
      await addressGetCountyByCityId(this.address.city.id).then(res => {
        this.CountyList = res.data.data
        if (
          !this.CountyList.some(item => {
            return item.id === this.address.county.id
          })
        ) {
          this.address.county = {}
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~'>>>';
// .add-address {
//   position: fixed;
//   width: 100%;
//   top: 15%;
//   left: 0;
//   z-index: 999;

// .address-cn {
//   background: #fff;
//   box-shadow: 0 3px 12px rgba(0, 0, 0, 0.34);
//   width: 713px;
//   height: 525px;
//   border-radius: 8px;
//   margin: 0 auto;
//   padding: 22px 60px;
//   box-sizing: border-box;
/deep/.el-input {
  position: relative;
  font-size: 14px;
  display: inline-block;
  width: 100% !important;
}

i {
  float: right;
  font-size: 28px;
  overflow: hidden;
  height: 28px;
  cursor: pointer;
  color: #2a2a2a;
}

h3.address-title {
  font-size: 24px;
  line-height: 40px;
  padding: 20px 0;
  color: #2a2a2a;
  margin-top: 15px;
  border-bottom: 1px solid #e8e8e8;
  font-weight: normal;
}

.btn_box {
  overflow: hidden;

  button {
    margin-right: 20px;
    float: right;
  }

  @{deep} .el-button--primary {
    &:hover {
      color: #fff;
    }

    &:active {
      background: #479a66 !important;
    }
  }
}

.cancel {
  background: #707070;
}

.el-form {
  margin-top: 20px;

  .address-top {
    overflow: hidden;
  }
}

.el-form-item {
  clear: both;

  .el-address {
    border: none;
  }

  @{deep} .el-form-item__label {
    line-height: 30px;
  }

  @{deep} .el-input__inner {
    border-color: #6d6d6d;
  }

  .el-address {
    select {
      width: 120px;
      height: 40px;
      border: 1px solid #6d6d6d;
      padding: 0 10px;
      box-sizing: border-box;
      color: #666;
      margin-right: 10px;
      border-radius: 5px;
      outline: none;

      option {
        color: #666;
        line-height: 40px;
      }
    }
  }
}

.form-phone,
.form-username {
  width: 49.5%;
  clear: none;
}

.address-list {
  .el-form-item {
    display: inline-block;
  }
}

.el-form--label-top /deep/ .el-form-item__label {
  float: none;
  margin-bottom: -10px;
  font-size: 16px;
  font-family: Source Han Sans CN, Source Han Sans CN-Normal;
  font-weight: normal;
  text-align: left;
  color: #242424;
}

@{deep}.el-dialog__header {
  padding: 20px 20px 10px !important;
}

@{deep}.el-dialog__body {
  padding: 0px 20px 30px;
}

.textarea-box {
  border: 1px solid #6d6d6d;
  border-radius: 4px;
  padding-bottom: 35px;
  padding-right: 5px;

  @{deep}.el-textarea__inner {
    border: 1px solid #fff !important;
  }

  @{deep}.el-textarea__inner :hover {
    border-color: #fff !important;
  }

  .recognize {
    float: right;
    width: 70px;
    height: 28px;
    font-size: 13px;
    line-height: 28px;
    text-align: center;
    border: 1px solid #53b578;
    border-radius: 2px;
    color: #53b578;
    cursor: pointer;
  }
}

// }
</style>
